export default __webpack_public_path__ + "static/media/trash.863c07f8.svg";